class YGScriptLoader extends HTMLElement {
  loadScript(url, fn) {
    if (url) {
      let loadScript = document.createElement('script')
      loadScript.src = url
      document.body.appendChild(loadScript)

      loadScript.onload = () => {
        fn()
      }

      loadScript.onerror = (err) => {
        console.error(err)
      }
    }
  }
}

class YGDetails extends HTMLElement {
  constructor() {
      super()
      this.init()
  }
  init() {
    // 这里放置自定义逻辑 
    let YGDetails = this.querySelectorAll('.yg-details')
    YGDetails.forEach((item) => {
      let title = item.querySelector('.yg-details-title');
      let content = item.querySelector('.yg-details-content');
      let btn = item.querySelector('.yg-right svg');
      this.clickTab(title, content , btn) ;
      
    })
  }

  clickTab(title, content, btn) {
      // title: title元素
      // content: content元素
      let height = content.offsetHeight + 12;
      content.style.height = '0';

      title.addEventListener("click",function(){
        if(content.classList.contains('active')){
            content.style.height = '0';
            content.style.paddingTop = '0';
            btn.style.transform = 'none';
            content.classList.remove('active')
        }else{
            content.style.height = `${height}px`;
            content.style.paddingTop = '12px';
            btn.style.transform = 'rotate(180deg)';
            content.classList.add('active');
        }
    })
  }
}
if (!window.customElements.get('yg-details')) {
  window.customElements.define('yg-details',YGDetails)
}

class YGCode extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.addEventListener("click", () => {
      const textToCopy = this.querySelector(".code-content").innerText;

      // 使用 Clipboard API 复制文本
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          this.querySelector(".yg-tip").style.opacity = "1";
          setTimeout(() => {
            this.querySelector(".yg-tip").style.opacity = "0";
          }, 500);
        })
        .catch((err) => {
          console.error("复制失败:", err);
        });
    });
  }
}

if (!window.customElements.get("yg-code")) {
  window.customElements.define("yg-code", YGCode);
}


document.addEventListener('DOMContentLoaded', function() {

  // 变体图片
  const element = document.querySelectorAll('.variant-picker__option-values label');
  element.forEach(item => {
    
    const customPropertyValue = item.style.getPropertyValue('--swatch-background');
    
    
    if (customPropertyValue.startsWith('url')) {
      item.classList.add('hasbgimg');
    } else{
      item.classList.remove('hasbgimg');
    }
  });

  if(document.querySelector('.product-gallery__thumbnail-list-wrapper') && document.querySelector('.product').getAttribute('data-autoplay') == 'true') {
    const speed = Number(document.querySelector('.product').getAttribute('data-speed'));
    
    setInterval(function(){
      if(document.querySelector('.product-gallery__thumbnail-list-wrapper .product-gallery__thumbnail[aria-current="true"]+.product-gallery__thumbnail')) {
        document.querySelector('.product-gallery__thumbnail-list-wrapper .product-gallery__thumbnail[aria-current="true"]+.product-gallery__thumbnail').click()
      } else {
        document.querySelector('.product-gallery__thumbnail-list-wrapper .product-gallery__thumbnail').click();
      }
    }, speed);
  }
  


});